<template>
  <div>
    <div class="modal-header d-lg-flex justify-content-between w-100">
      <h3>Nuevo Cobro</h3>
    </div>
    <div class="mt-n3 modal-body pb-0">
      <div class="row px-4">
        <div class="col-12">
          <label class="form-control-label">Cliente *</label>
          <multiselect
            v-model="form.selCustomer"
            :options="customers || []"
            :loading="!customers"
            placeholder="Selecciona Cliente"
            track-by="CardCode"
            :custom-label="({ CardCode, CardName }) => `${CardName} (${CardCode})`"
            class="mb-3"
            :show-labels="false"
            @select="onSelectCustomer"
          />
        </div>

        <hr class="col-12 mb-3 mt-0 p-0" />

        <div class="col-6 col-lg-4">
          <label class="form-control-label">Fecha de contabilización *</label>
          <flat-picker
            v-model="form.DocDate"
            :config="{ allowInput: true, maxDate: todayDate, minDate: 
              !['dannasandoval@canplast.com.mx', 'ofelialujan@canplast.com.mx','darinkahernandez@canplast.com.mx','lizethflores@canplast.com.mx','danielamuniz@canplast.com.mx'].includes(user.email) ? firstDayOfMonth : null }"
            style="cursor: pointer"
            class="form-control input-group-alternative datepicker mb-3"
          />
        </div>

        <div class="col-6 col-lg-4">
          <label class="form-control-label">Fecha de vencimiento *</label>
          <flat-picker
            v-model="form.DueDate"
            :config="{ allowInput: true }"
            style="cursor: pointer"
            class="form-control input-group-alternative datepicker mb-3"
          />
        </div>

        <div class="col-6 col-lg-4">
          <label class="form-control-label">Fecha de documento *</label>
          <flat-picker
            v-model="form.TaxDate"
            :config="{ allowInput: true }"
            style="cursor: pointer"
            class="form-control input-group-alternative datepicker mb-3"
          />
        </div>

        <hr class="col-12 mb-3 mt-0 p-0" />

        <div class="col-12 d-flex align-items-center ">
          <label class="form-control-label m-0">
            Condiciones de pago del cliente:
          </label>
          <span class="text-sm m-0 ml-2" v-if="payment">
            {{ payment.PaymentTermsGroupName }}
          </span>
        </div>
        <div class="col-12 d-flex align-items-center mb-3">
          <label class="form-control-label m-0">CEDIS:</label>
          <span class="text-sm m-0 ml-2" v-if="customerData">
            {{ customerData.U_CEDIS }}
          </span>
        </div>

        <hr class="col-12 mb-3 mt-0 p-0" />

        <div class="col-6">
          <label class="form-control-label">Vía de Pago *</label>
          <multiselect
            v-model="form.selPayMethod"
            :options="payMethodsOpt"
            :disabled="!customerData"
            :loading="form.selCustomer && !customerData"
            placeholder="Selecciona Vía de Pago"
            track-by="value"
            label="description"
            class="mb-3"
            :show-labels="false"
            @select="onSelectPayMethod"
            :allow-empty="false"
          />
        </div>

        <div
          v-if="form.selPayMethod && form.selPayMethod.value !== '01'"
          class="col-6"
        >
          <label class="form-control-label">Cuenta Beneficiario *</label>
          <multiselect
            v-model="form.selBankAccount"
            :options="bankAccountOptions || []"
            track-by="AccNo"
            :custom-label="({ AccNo, AccountName }) => `${AccNo} - ${AccountName}`"
            placeholder="Selecciona Cuenta Beneficiario"
            class="mb-3"
            :show-labels="false"
          />
        </div>

        <div v-if="form.selPayMethod" class="col-6">
          <label class="form-control-label">Cuenta de Pago *</label>
          <multiselect
            v-model="form.selPayAccount"
            :options="payAccountsOpt"
            track-by="key"
            :custom-label="({ key, Description }) => `${key} - ${Description}`"
            placeholder="Selecciona Cuenta de Pago"
            class="mb-3"
            :show-labels="false"
          >
          </multiselect>
        </div>

        <div
          v-if="
            form.selPayMethod &&
            ['02', '03'].includes(form.selPayMethod.value) &&
            customerData
          "
          class="col-6"
        >
          <div v-if="customerData.BPBankAccounts.length">
            <label class="form-control-label">
              Cuenta Ordenante
              <span v-if="form.selPayMethod.value === '02'">*</span>
            </label>
            <multiselect
              v-model="form.selOrdenant"
              :options="customerData.BPBankAccounts"
              placeholder="Selecciona Cuenta Ordenante"
              track-by="InternalKey"
              :custom-label="({ AccountNo, Branch }) => `${AccountNo} ${Branch ? '- ' + Branch : ''}`"
              class="mb-3"
              :show-labels="false"
              @select="onSelectPayMethod"
            />
          </div>
          <h5 v-else class="mb-3" style="margin-top: 29px;">
            Este cliente no tiene cuentas registradas
          </h5>
        </div>

        <div
          v-if="form.selPayMethod && form.selPayMethod.value === '04'"
          class="col-4"
        >
          <base-input
            v-model="form.creditCardNumber"
            label="Tarjeta de crédito"
            placeholder="(Últimos 4 dígitos)"
            maxlength="4"
            required
            inputClasses="input-group-alternative"
            class="mb-3"
          />
        </div>

        <div
          v-if="form.selPayMethod && form.selPayMethod.value === '04'"
          class="col-4"
        >
          <label class="form-control-label">Fecha de expiración *</label>
          <flat-picker
            v-model="form.creditCardExpiration"
            :config="{ allowInput: true }"
            style="cursor: pointer"
            class="form-control input-group-alternative datepicker mb-3"
          />
        </div>

        <div
          v-if="form.selPayMethod && form.selPayMethod.value === '04'"
          class="col-4"
        >
          <base-input
            v-model="form.voucherNum"
            label="Número de documento"
            placeholder="Número de documento"
            inputClasses="input-group-alternative"
            maxlength="8"
            required
            class="mb-3"
          />
        </div>

        <base-input
          v-if="form.selPayMethod"
          v-model="form.CounterReference"
          label="Referencia"
          inputClasses="input-group-alternative"
          placeholder="Referencia"
          class="col-4 mb-3"
          maxlength="8"
        />

        <base-input
          v-if="form.selPayMethod"
          v-model="form.U_BankReference"
          label="Referencia Bancaria"
          inputClasses="input-group-alternative"
          placeholder="Referencia Bancaria"
          class="col-4 mb-3"
          required
        />
        <div v-if="form.selPayMethod" class="col-4">
          <label class="form-control-label">
            <span v-if="form.selPayMethod.value === '02'">
              Fecha de cheque *
            </span>
            <span v-else-if="form.selPayMethod.value === '03'">
              Fecha de transferencia *
            </span>
            <span v-else>Fecha de Pago *</span>
          </label>
          <flat-picker
            v-model="form.paymentDate"
            :config="{ allowInput: true, maxDate: todayDate }"
            style="cursor: pointer"
            class="form-control input-group-alternative datepicker mb-3"
          />
        </div>

        <hr class="col-12 mb-3 mt-0 p-0" />

        <div class="col-4">
          <label class="form-control-label">Moneda *</label>
          <multiselect
            v-model="form.selCurrency"
            :options="currencyOpt"
            placeholder="Selecciona Moneda"
            track-by="key"
            label="key"
            class="mb-3"
            :show-labels="false"
            :allow-empty="false"
            @select="resetCurrency"
          />
        </div>

        <div class="col-4">
          <base-checkbox
            v-if="form.selCurrency && form.selCurrency.key !== 'MXP'"
            v-model="form.useDocRate"
            style="margin-top: 29px;"
          >
            Usar tipo de cambio del sistema
          </base-checkbox>
        </div>

        <div class="col-4">
          <base-input
            v-if="!form.useDocRate && form.selCurrency && form.selCurrency.key !== 'MXP'"
            v-model="form.DocRate"
            label="Tipo de cambio"
            placeholder="Tipo de cambio"
            inputClasses="input-group-alternative"
            type="number"
            min="0"
            class="mb-3"
            required
          />
        </div>

        <hr class="col-12 mb-3 mt-0 p-0" />

        <div class="col-3 d-flex align-items-center mb-3">
          <base-checkbox v-model="form.payOnAccount" @input="resetTotal">
            Pago a cuenta
          </base-checkbox>
        </div>

        <base-input
          v-if="form.payOnAccount"
          v-model="form.total"
          label="Total"
          inputClasses="input-group-alternative"
          placeholder="Total"
          type="number"
          min="0"
          required
          class="col-4 mb-3"
        />
        <div class="col-3" v-if="!form.payOnAccount">
          <multiselect
            v-model="form.payment"
            :options="['Contado', 'Crédito']"
            class="mb-3 small-multiselect"
            :show-labels="false"
            :allow-empty="false"
            @select="resetTotal"
          />
        </div>
        <div class="col-3" v-if="!form.payOnAccount">
          <multiselect
            v-model="form.iva"
            :options="['Con IVA', 'Sin IVA']"
            class="mb-3 small-multiselect"
            :show-labels="false"
            :allow-empty="false"
            @select="resetTotal"
          />
        </div>
        <div v-if="!form.payOnAccount && customerData" class="col-12 row p-0 m-0">
            <div class="col-12 mb-3">
              <SelectInvoices
                ref="invTables"
                :availableInvoices="openInvoicesByCurrency"
                :currency="form.selCurrency"
                @updated="updateData"
              />
            </div>
        </div>

        <hr class="col-12 mb-3 mt-0 p-0" />
      </div>
    </div>
    <div
      :class="[
        'd-flex mb-4 modal-body py-0',
        creatingIncomingPayment ? 'justify-content-center': 'justify-content-end',
      ]"
    >
      <div v-b-popover.hover.focus.bottom.html="popoverData">
        <base-button
          v-if="!creatingIncomingPayment"
          @click="createIncomingPayment"
          icon="fa fa-check"
          :disabled="!validation.valid"
        >
          Crear Cobro
        </base-button>
      </div>

      <base-loader v-if="creatingIncomingPayment" text="Creando Cobro"/>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import flatPicker from "vue-flatpickr-component";
import BaseLoader from "@/components/BaseLoader.vue";
import banks from "@/data/banks.json";
import moment from "moment";
import { getAuth } from "firebase/auth";
import axios from "axios";
import paymentMethods from "@/data/paymentMethods.json";
import currency from "@/data/currency.json";
import paymentAccounts from "@/data/paymentAccounts.json";
import Formats from "@/mixins/Formats.js";
import SelectInvoices from "./SelectInvoices.vue";

export default {
  mixins: [Formats],
  components: {
    Multiselect,
    flatPicker,
    BaseLoader,
    SelectInvoices,
  },
  data() {
    return {
      HANA_URL: process.env.VUE_APP_HANA_URL,
      customers: null,
      emails: [],
      bankAccountOptions: null,
      todayDate: moment().format("YYYY-MM-DD"),
      payment: null,
      customerData: null,
      openInvoices: null,
      selInvoices: null,
      creatingIncomingPayment: false,
      rates: null,
      firstDayOfMonth: moment().startOf("month").format("YYYY-MM-DD"),
      form: {
        selCustomer: null,
        TaxDate: null,
        DueDate: null,
        DocDate: null,
        selPayMethod: null,
        selCurrency: null,
        selBankAccount: null,
        total: null,
        selPayAccount: null,
        CounterReference: null,
        U_BankReference: null,
        useDocRate: null,
        DocRate: null,
        selOrdenant: null,
        payOnAccount: null,
        creditCardNumber: null,
        creditCardExpiration: null,
        voucherNum: null,
        payment: null,
        paymentDate: null,
        iva: null,
      },
    };
  },
  created() {
    this.user = getAuth().currentUser;
    this.payMethodsOpt = paymentMethods.filter((x) => {
      return ["01", "02", "03", "04"].includes(x.value);
    });
    this.currencyOpt = currency;
    this.payAccountsOpt = [];
    if(['claragonzalez@canplast.com.mx','carmencoutino@canplast.com.mx','nallelygonzalez@canplast.com.mx','yolandachable@canplast.com.mx','alexamendez@canplast.com.mx','citlaliherrera@canplast.com.mx','angelicapatricio@canplast.com.mx','bereniceterrazas@canplast.com.mx','misaelrobles@canplast.com.mx'].includes(this.user.email)){
      this.payAccountsOpt.push(paymentAccounts.find(x => x.key === '101-001-002'));
    }
    else{
      this.payAccountsOpt = paymentAccounts;
    }

    this.form.TaxDate = moment().format("YYYY-MM-DD");
    this.form.DueDate = moment().format("YYYY-MM-DD");
    this.form.DocDate = moment().format("YYYY-MM-DD");
    this.form.creditCardExpiration = moment().format("YYYY-MM-DD");
    this.form.paymentDate = moment().format("YYYY-MM-DD");

    this.form.payOnAccount = true;
    this.form.selCurrency = this.currencyOpt.find((x) => x.key === "MXP");
    this.form.payment = "Contado";
    this.form.iva = "Con IVA";

    axios
      .get(`/api/customers`)
      .then((res) => {
        this.customers = res.data.value;
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(`/api/house_bank_accounts`)
      .then((res) => {
        this.bankAccountOptions = [];
        if(['claragonzalez@canplast.com.mx','carmencoutino@canplast.com.mx','nallelygonzalez@canplast.com.mx','yolandachable@canplast.com.mx','alexamendez@canplast.com.mx','citlaliherrera@canplast.com.mx','angelicapatricio@canplast.com.mx','bereniceterrazas@canplast.com.mx','misaelrobles@canplast.com.mx'].includes(this.user.email)){
          this.bankAccountOptions.push(res.data.value.find(x => x.AccNo === '0449425918'));
          this.bankAccountOptions.push(res.data.value.find(x => x.AccNo === '4003007895'));
        }
        else{
          this.bankAccountOptions = res.data.value;
          //this.bankAccountOptions = this.bankAccountOptions.filter(x => x.AccNo !== '4003007895' && x.AccNo !== '7000126490');
        }
        this.bankAccountOptions = this.bankAccountOptions.filter(x => x.AccNo !== '0004887025');

      })
      .catch((err) => {
        console.error(err);
      });

      const date = moment().format('YYYYMMDD');
      axios.get(`/api/getCurrencies?date=${date}`)
      .then(res => {
        if(res.data.Date){
          this.rates = res.data;
        }
      })
      .catch(err => {
        console.error(err); 
      });
  },
  methods: {
    updateData(invoices, total){
      this.selInvoices = invoices;
      this.form.total = total
    },
    onSelectCustomer(data) {
      this.customerData = null;
      this.form.selPayMethod = null;
      this.form.selOrdenant = null;
      this.openInvoices = null;
      this.form.total = null;
      this.payment = null;
      axios
        .get(`/api/customers/${data.CardCode}`)
        .then((res) => {
          this.emails = res.data.ContactEmployees
            .filter((contacto) => contacto.U_TS_EnvioPago === "SI" && contacto.E_Mail)
            .map((contacto) => contacto.E_Mail);

          const {
            BPBankAccounts,
            CreditCardCode,
            CreditCardExpiration,
            CreditCardNum,
            DefaultAccount,
            DefaultBankCode,
            U_TS_RegFiscal,
            PayTermsGrpCode,
            U_CEDIS,
          } = res.data;

          this.customerData = {
            BPBankAccounts,
            CreditCardCode,
            CreditCardExpiration,
            CreditCardNum,
            DefaultAccount,
            DefaultBankCode,
            U_TS_RegFiscal,
            PayTermsGrpCode,
            U_CEDIS,
          };

          axios
            .get(`/api/paymentsByCode?code=${this.customerData.PayTermsGrpCode}`)
            .then((res) => {
              this.payment = res.data.value.find(
                (x) => x.GroupNumber === this.customerData.PayTermsGrpCode
              );
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });

      axios
        .all([
          axios.get(`/api/invoices/open/${data.CardCode}`),
          axios.get(`${this.HANA_URL}/api/invoices/pending?CardCode=${data.CardCode}`),
        ])
        .then(
          axios.spread((openInvoices, pendingPayments) => {
            openInvoices.data.value.forEach((invoice) => {
              const pending = pendingPayments.data.find((x) => x.DocNum === invoice.DocNum);
              if (pending) {
                if (invoice.DocCurrency === "MXP") {
                  invoice.sum = invoice.DocTotal - parseFloat(pending["Saldo Pendiente"]);
                } else {
                  // USD, EUR
                  invoice.sum = invoice.DocTotalFc - parseFloat(pending["Saldo Pendiente ME"]);
                }
              } else {
                invoice.sum = 0;
              }
            });
            this.openInvoices = openInvoices.data.value;
          })
        )
        .catch((error) => {
          console.error(error);
        });
    },
    onSelectPayMethod(data) {
      if (data.value === "02") {
        // Cheque nominativo
        if (!this.customerData.BPBankAccounts.length) {
          this.$swal({
            title: "No permitido",
            text:
              "El método de pago de cheque nominativo en este cliente no esta habilitado por cuenta ordenante faltante.",
            icon: "warning",
            customClass: {
              container: "custom-swal-on-top",
            },
          }).then(() => {
            this.form.selPayMethod = null;
          });
        }
      } else if (
        data.value === "04" &&
        this.customerData.CreditCardCode === -1
      ) {
        // Tarjeta de crédito
        this.$swal({
          title: "No permitido",
          text:
            "El método de pago de tarjeta de crédito en este cliente no esta habilitado por tarjeta faltante en el cliente.",
          icon: "warning",
          customClass: {
            container: "custom-swal-on-top",
          },
        }).then(() => {
          this.form.selPayMethod = null;
        });
      }
    },
    resetCurrency() {
      this.form.useDocRate = true;
      this.form.DocRate = null;
      this.resetTotal();
    },
    resetTotal() {
      this.form.total = null;
      this.selInvoices = null;
      if(this.$refs.invTables){
        this.$nextTick(() => {
          if(this.$refs.invTables){
            this.$refs.invTables.resetSelected();
          }
        })
      }
    },
    createIncomingPayment() {
      this.creatingIncomingPayment = true;
      let cashAccount = null;
      let cashSum = null;
      let checkAccount = null;
      let transferAccount = null;
      let transferDate = null;
      let transferSum = null;
      let nomBancoOrd = null;
      let ctaOrdnt = null;
      let paymentInvoices = [];
      let paymentCreditCards = [];
      let paymentChecks = [];
      let documentosRelacionados = [];
      let timbrar = false;
      let nomBancoBen = null;
      let ctaBnfcrio = null;

      if (this.form.selPayMethod.value === "01") {
        // Efectivo
        cashAccount = this.form.selPayAccount.key;
        cashSum = parseFloat(this.form.total);
      } else if (this.form.selPayMethod.value === "02") {
        // Cheque Nominativo
        checkAccount = this.form.selPayAccount.key;
        nomBancoOrd = banks[this.form.selOrdenant.BankCode];
        ctaOrdnt = this.form.selOrdenant.AccountNo;
        nomBancoBen = banks[this.form.selBankAccount.BankCode];
        ctaBnfcrio = this.form.selBankAccount.AccNo;
        paymentChecks = [
          {
            DueDate: this.form.paymentDate,
            BankCode: this.form.selOrdenant.BankCode,
            AccounttNum: this.form.selOrdenant.AccountNo,
            CheckSum: parseFloat(this.form.total),
            CheckAccount: this.form.selPayAccount.key,
          },
        ];
      } else if (this.form.selPayMethod.value === "03") {
        // Transferencia electrónica de fondos
        transferAccount = this.form.selPayAccount.key;
        transferDate = this.form.paymentDate;
        transferSum = parseFloat(this.form.total);
        nomBancoBen = banks[this.form.selBankAccount.BankCode];
        ctaBnfcrio = this.form.selBankAccount.AccNo;
        if (this.form.selOrdenant) {
          nomBancoOrd = banks[this.form.selOrdenant.BankCode];
          ctaOrdnt = this.form.selOrdenant.AccountNo;
        }
      } else if (this.form.selPayMethod.value === "04") {
        // Tarjeta de crédito
        nomBancoBen = banks[this.form.selBankAccount.BankCode];
        ctaBnfcrio = this.form.selBankAccount.AccNo;
        paymentCreditCards = [
          {
            CreditCard: this.form.selCustomer.CreditCardCode,
            CreditSum: parseFloat(this.form.total),
            CreditCardNumber: this.form.creditCardNumber,
            CardValidUntil: this.form.creditCardExpiration,
            VoucherNum: this.form.voucherNum,
          },
        ];
      }

      if (!this.form.payOnAccount) {
        this.selInvoices.forEach((invoice) => {
          if (this.form.selCurrency.key === "MXP") {
            paymentInvoices.push({
              DocEntry: invoice.DocEntry,
              SumApplied: invoice.charge,
              AppliedSys: invoice.charge,
            });
          } else {
            // USD, EUR
            paymentInvoices.push({
              DocEntry: invoice.DocEntry,
              AppliedFC: invoice.charge,
            });
          }
          documentosRelacionados.push({
            DocNum: invoice.DocNum,
            UUID: invoice.U_WebUUID || invoice.U_TS_ReportID,
            SumApplied: invoice.charge,
          });
        });
        if (this.form.payment === "Crédito") {
          timbrar = true;
        }
      }

      if (process.env.NODE_ENV !== "production") {
        this.emails = [this.user.email];
      }
      if (this.payment.GroupNumber === 8) {
        this.emails = [];
      }
      
      let docRate = null;
      if(this.form.selCurrency.key !== "MXP"){
        if(this.form.useDocRate){
          docRate = this.rates[this.form.selCurrency.key];
        } else {
          docRate = this.form.DocRate;
        }
      }
      
      const json = {
        pago: {
          CardCode: this.form.selCustomer.CardCode,
          CashAccount: cashAccount,
          CashSum: cashSum,
          CheckAccount: checkAccount,
          TransferAccount: transferAccount,
          TransferDate: transferDate,
          TransferSum: transferSum,
          U_B1SYS_PmntMethod: this.form.selPayMethod.value,
          U_TS_CtaBnfcrio: ctaBnfcrio,
          U_BankReference: this.form.U_BankReference,
          U_TS_CtaOrdnt: ctaOrdnt,
          U_TS_GenType: "N",
          U_TS_MPgo: this.form.selCurrency.iso,
          U_TS_NomBancoBen: nomBancoBen,
          U_TS_NomBancoOrd: nomBancoOrd,
          U_TS_PmntMethod: this.form.selPayMethod.value,
          DocCurrency: this.form.selCurrency.key,
          DocRate: docRate,
          CounterReference: this.form.CounterReference,
          Remarks: "Creado desde la Consola por " + this.user.displayName,
          DueDate: this.form.DueDate, // Fecha de vencimiento
          DocDate: this.form.DocDate, // Fecha de contabilización
          TaxDate: this.form.TaxDate, // Fecha de documento 
          PaymentInvoices: paymentInvoices,
          PaymentCreditCards: paymentCreditCards,
          PaymentChecks: paymentChecks,
        },
        extra: {
          regimenFiscal: this.customerData.U_TS_RegFiscal,
          documentosRelacionados: documentosRelacionados,
          timbrar: timbrar,
          fechaPago: this.form.paymentDate,
          Date: moment().format('YYYY-MM-DDTHH:mm:ss')
        },
        emails: this.emails,
      };
      console.log("JSON", json);

      axios
        .post(`/api/fpt/pagos`, json)
        .then((res) => {
          console.log("🟦 POST", res);

          if (res.data.status) {
            switch (res.data.status) {
              case "Creada":
                this.$emit("reload");
                this.$swal({
                  title: res.data.status,
                  text: res.data.msg,
                  icon: "success",
                  customClass: {
                    container: "custom-swal-on-top",
                  },
                }).then(() => {
                  this.copyToClipboard(res.data.res.DocNum);
                  this.$emit("close");
                });
                break;
              case "Creada con error en email":
                this.$emit("reload");
                this.$swal({
                  title: res.data.status,
                  text: res.data.msg,
                  icon: "warning",
                  customClass: {
                    container: "custom-swal-on-top",
                  },
                }).then(() => {
                  this.copyToClipboard(res.data.res.DocNum);
                  this.$emit("close");
                });
                break;
              case "Creada en SAP con error de timbrado":
                this.$emit("reload");
                this.$swal({
                  title: res.data.status,
                  text: res.data.msg,
                  icon: "error",
                  customClass: {
                    container: "custom-swal-on-top",
                  },
                }).then(() => {
                  this.copyToClipboard(res.data.res.DocNum);
                  this.$emit("close");
                });
                break;
              case "Error en sap":
                this.$swal({
                  title: res.data.status,
                  text: res.data.msg,
                  icon: "error",
                  customClass: {
                    container: "custom-swal-on-top",
                  },
                });
                break;
              default:
                break;
            }
          } else if (res.data.error) {
            if (res.data.error.error) {
              this.$swal({
                title: "Error",
                text: res.data.error.error.message.value,
                icon: "error",
                customClass: {
                  container: "custom-swal-on-top",
                },
              });
            } else {
              this.$swal({
                title: "Error",
                text: "Ocurrió un error al crear el cobro.",
                icon: "error",
                customClass: {
                  container: "custom-swal-on-top",
                },
              });
              console.error(res.data);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.creatingIncomingPayment = false;
        });
    },
    copyToClipboard(docNum) {
      navigator.clipboard.writeText(docNum);
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        customClass: {
          container: "custom-swal-on-top",
        },
      });
      Toast.fire({
        text: `Pago #${docNum} copiado`,
      });
    },
  },
  computed: {
    openInvoicesByCurrency() {
      if (!this.openInvoices) return [];
      return this.openInvoices.filter((x) => {
        const {payment, iva} = this.form;

        let paymentValidation = false;
        if (payment === "Contado") {
          paymentValidation = [8, 23, 19].includes(x.PaymentGroupCode);
        } else if (payment === "Crédito") {
          paymentValidation = ![8, 23, 19].includes(x.PaymentGroupCode);
        }

        const ivaField = x.DocCurrency === "MXP" ? 'VatSumSys' : 'VatSumFc'; 
        let ivaValidation = false;
        if (iva === "Con IVA") {
          ivaValidation = x[ivaField] > 0;
        } else if (iva === "Sin IVA") {
          ivaValidation = !x[ivaField];
        }

        return (
          x.DocCurrency === this.form.selCurrency.key && 
          paymentValidation &&
          ivaValidation 
        );
      });
    },
    validation() {
      const { 
        selCustomer, TaxDate, DueDate, DocDate, U_BankReference, payOnAccount, total, selPayMethod, selOrdenant, paymentDate, selBankAccount, selPayAccount, creditCardNumber, creditCardExpiration, voucherNum, selCurrency, useDocRate, DocRate
      } = this.form;

      const complete = {
        "Cliente": selCustomer,
        "Fecha de contabilización": DocDate,
        "Fecha de vencimiento": DueDate,
        "Fecha de documento": TaxDate,
        "Vía de Pago": selPayMethod,
        "Referencia Bancaria": U_BankReference != null,
        "Moneda": selCurrency,
        "Tipo de cambio": !selCurrency || selCurrency.key === "MXP" || (useDocRate && this.rates) || DocRate,
        "Facturas Seleccionadas": payOnAccount || (
          this.selInvoices &&
          this.selInvoices.every((x) => x.charge > 0 && (x.U_WebUUID || x.U_TS_ReportID))
        ),
        "Total": total && total > 0,
      };

      const paymentValidations = {
        "01": { // Efectivo
          "Cuenta de Pago": selPayAccount,
        },
        "02": { // Cheque Nominativo
          "Cuenta Ordenante": selOrdenant,
          "Cuenta Beneficiario": selBankAccount,
          "Cuenta de Pago": selPayAccount,
          "Fecha de Pago": paymentDate,
        },
        "03": { // Transferencia electrónica de fondos
          "Fecha de Pago": paymentDate,
          "Cuenta de Pago": selPayAccount,
          "Cuenta Beneficiario": selBankAccount,
        },
        "04": { // Tarjeta de crédito
          "Tarjeta de Crédito (4 dígitos)": creditCardNumber?.length === 4,
          "Fecha de expiración": creditCardExpiration,
          "Número de documento": voucherNum,
          "Cuenta Beneficiario": selBankAccount,
        },
      };

      if (selPayMethod) {
        Object.assign(complete, paymentValidations[selPayMethod.value] || {});
      }

      return {
        valid: Object.values(complete).every((x) => x),
        missing: Object.keys(complete).filter((x) => !complete[x]),
      };
    },
    popoverData() {
      if (this.validation.missing.length > 0) {
        return {
          title: "<small><b>Falta completar los campos:</b></small>",
          content: `<ul><li>${this.validation.missing.join("<li>")}</ul>`,
          placement: "righttop",
        };
      } else {
        return null;
      }
    },
  },
};
</script>

<style>
.custom-swal-on-top {
  z-index: 9999 !important;
}
</style>
